export const PAYMENT_CODES = {
    FREE_TEXT: 1,
    MASKED_INPUT: 2,
    PREDEFINED_DROPDOWN: 3,
    FIXED_VALUE: 4,
    MASK_DROPDOWN: 5,
    DROPDOWN_MASK: 6,
    HIERARCHICAL_CODES: 7,
};

export const VALIDATION_OPTIONS = {
    NOT_APPLICABLE: 0,
    DISPLAY_AS_DROPDOWN: 1,
    AUTOCOMPLETE: 2,
    VALIDATE_BY_API: 3,
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-enum.js